import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  DeleteOpenApiKeyMutation as _DeleteOpenApiKeyMutation,
  DeleteOpenApiKeyInput,
} from '@/gql/graphql';
import meKeys from '../../queries/me/keyFactory';

const DeleteOpenApiKeyMutation = graphql(`
  mutation DeleteOpenApiKey($input: DeleteOpenApiKeyInput!) {
    deleteOpenApiKey(input: $input) {
      __typename
      ... on DeleteOpenApiKeyResponseSuccess {
        id
      }
      ... on DeleteOpenApiKeyResponseError {
        message
      }
    }
  }
`);

const useDeleteOpenApiKey = (
  options?: UseMutationOptions<
    _DeleteOpenApiKeyMutation,
    unknown,
    DeleteOpenApiKeyInput
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => {
      return gqlClient.request(DeleteOpenApiKeyMutation, {
        input: variables,
      });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.openApiKeys(),
      });
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};

export default useDeleteOpenApiKey;
